export const voidFunction = (): void => {};
